export default __webpack_public_path__ + "KaTeX_Typewriter-Regular.4f31d033d446bb37ed6054ae5d39bd22.woff2";